export default __webpack_public_path__ + "static/media/emoji-write.f56ed4c3.svg";